import { gql } from '@apollo/client';

export const GOOD_AMOUNT_HISTORY = gql`
  query GoodHistory($input: GoodHistoryInput!) {
    goodHistory(input: $input) {
      data {
        comment
        created_at
        delta
        initiator {
          first_name
          last_name
          middle_name
          uuid
        }
        operation
        quantity_after
      }
      paginatorInfo {
        currentPage
        lastPage
      }
    }
  }
`;

export const GOOD_AMOUNT_HISTORY_CSV = gql`
  query GoodHistory($input: GoodHistoryInput!) {
    goodHistory(input: $input) {
      url
    }
  }
`;
